import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { connectionClient } from '../client';

export let connectionsLoader = createLoader({
  name: 'connections',
  fetch: (i: { organizationId: string }) =>
    withAuth(() => connectionClient.connection.list(i)),
  mutators: {
    oauthGetUrl: (i: { provider: string; state: string }, { input }) =>
      withAuth(() => connectionClient.connection.oauth.getUrl({ ...input, ...i })),

    oauthExchangeCode: (i: { provider: string; code: string; state: string }, { input }) =>
      withAuth(() => connectionClient.connection.oauth.exchangeCode({ ...input, ...i }))
  }
});

export let useConnections = (organizationId: string | null | undefined) => {
  return connectionsLoader.use(organizationId ? { organizationId } : null);
};

export let connectionErrorsLoader = createLoader({
  name: 'connectionErrors',
  fetch: (i: { organizationId: string; connectionId: string }) =>
    withAuth(() => connectionClient.connection.listErrors(i)),
  mutators: {}
});

export let useConnectionErrors = (
  organizationId: string | null,
  connectionId: string | null
) => {
  return connectionErrorsLoader.use(
    connectionId && organizationId ? { connectionId, organizationId } : null
  );
};

export let useOauth = (organizationId: string | null) => {
  let connections = useConnections(organizationId);

  let oauthGetUrl = connections.useMutator('oauthGetUrl');
  let oauthExchangeCode = connections.useMutator('oauthExchangeCode');

  return {
    oauthGetUrl,
    oauthExchangeCode
  };
};

export let providersLoader = createLoader({
  name: 'providers',
  fetch: (i: { organizationId: string }) =>
    withAuth(() => connectionClient.connection.listProviders(i)),
  mutators: {}
});

export let useProviders = (organizationId: string | null) => {
  let providers = providersLoader.use(organizationId ? { organizationId } : null);

  return providers;
};

export let connectionLoader = createLoader({
  name: 'connection',
  parents: [connectionsLoader],
  fetch: (i: { connectionId: string; organizationId: string }) =>
    withAuth(() => connectionClient.connection.get(i)),
  mutators: {
    update: (
      i: {
        name?: string;
      },
      { input }
    ) =>
      withAuth(() =>
        connectionClient.connection.update({
          ...input,
          ...i
        })
      ),

    delete: (_, { input }) => withAuth(() => connectionClient.connection.delete(input))
  }
});

export let useConnection = (organizationId: string | null, connectionId: string | null) => {
  let connection = connectionLoader.use(
    connectionId && organizationId ? { connectionId, organizationId } : null
  );

  return {
    ...connection,
    updateMutator: connection.useMutator('update'),
    deleteMutator: connection.useMutator('delete')
  };
};
